<template>
  <div :style="styles.base" @click="handleClickEvent()">
    <div :class="getCss('goods-container')" ref="displayGoodsContainer">
      <template v-if="goodsList.length > 0">
        <div :class="getCss('arrow-left')">
          <img
            :src="configurationData.leftBackgroundImage"
            v-if="!!configurationData.leftBackgroundImage && goodsList.length > 1 "
            :class="getCss('arrow-left-icon')"
            @click="touchMovePre"
          />
        </div>
        <div :class="getCss('goods-list-window')">
          <div
            :class="getCss('goods-list-scroller')"
            style="transform: translate3d(0, 0, 0);transition: -webkit-transform 0.3s ease 0s;"
            ref="goodsListScroller"
          >
            <ul
              v-for="(data, index) in goodsList"
              :class="getCss('list')"
              :key="`${Math.floor(Math.random()*10000)}${index}`"
            >
              <template v-for="(item, idx) in data">
                <li
                  :key="idx"
                  :class="getCss('item')"
                >
                  <div :class="getCss('img')" :style="goodsItemStyle">
                    <img
                      :src="item.goodsImg"
                    >
                  </div>
                  <div :class="getCss('info')">
                    <div
                      :class="getCss(['name', goodsItemGoodsNameMaxLength(data)  > 7 ? 'two-line' : 'one-line'])"
                      :style="goodsInfoNameStyle"
                    >
                      <span :style="goodsNameStyle">{{ item.goodsName }}</span>
                    </div>
                    <div
                      :class="getCss('price')"
                      :style="goodsInfoPriceStyle">
                      {{ `￥${(item.presentPrice / 100).toFixed(2)}` }}
                    </div>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>
        <div :class="getCss('arrow-right')">
          <img
            :src="configurationData.rightBackgroundImage"
            v-if="!!configurationData.rightBackgroundImage && goodsList.length > 1 "
            :class="getCss('arrow-right-icon')"
            @click="touchMoveNext"
          />
        </div>
      </template>
      <template v-else>
        <div :class="getCss('banner')">
          <div :style="noGoodsListStyle" :class="getCss('no-goods-list')"></div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { componentBaseMixin } from '@tencent/ceiba-base-components';

export default {
  name: 'CPublicMallRecommend',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-mall-recommend-',
      // 当前滚动的index
      currentIndex: 0,
      list: [],
      autoPlayTimer: null, // 自动轮播定时器
    };
  },
  computed: {
    goodsItemStyle() {
      const { goodsItemBackgroundImage } = this.configurationData;
      return {
        backgroundImage: `url(${goodsItemBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
      };
    },
    noGoodsListStyle() {
      const { noGoodsBackgroundImage } = this.configurationData;
      return {
        backgroundImage: `url(${noGoodsBackgroundImage})`,
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
      };
    },
    goodsItemGoodsNameMaxLength() {
      return (list = []) => {
        let maxLength = 0;
        list.forEach((item) => {
          const { goodsName } = item;
          const length = this.getStringSize(goodsName);
          if (length > maxLength) {
            maxLength = length;
          }
        });
        return maxLength;
      };
    },
    goodsInfoNameStyle() {
      const { goodsInfoNameStyle = { color: '#fff' } } = this.styles;
      return {
        ...goodsInfoNameStyle,
      };
    },
    goodsInfoPriceStyle() {
      const { goodsInfoPriceBackgroundImage } = this.configurationData;
      const { goodsInfoPriceStyle = { color: '#fff' } } = this.styles;
      return {
        backgroundImage: `url(${goodsInfoPriceBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
        ...goodsInfoPriceStyle,
      };
    },
    goodsNameStyle() {
      return {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkitBoxOrient': 'vertical',
        '-webkitLineClamp': 2,
      };
    },
    /**
     * 每行显示的道具数
     * @returns {number}
     */
    rowGoodsNum() {
      const { rowGoodsNum = 3 } = this.configurationData;
      return rowGoodsNum;
    },
    /**
     * 展示推荐道具数量
     * @returns {number}
     */
    goodsNum() {
      const { goodsNum = 10 } = this.configurationData;
      return goodsNum;
    },
    /**
     * 展示推荐道具列表
     * @returns {*[]}
     */
    goodsList() {
      if (this.list.length === 0) {
        return [];
      }
      const list = [];
      let temp = [];
      const num = this.list.length < this.goodsNum ? this.list.length : this.goodsNum;
      for (let i = 0; i < num; i++) {
        temp.push({ ...this.list[i] });
        if (temp.length === this.rowGoodsNum) {
          list.push(temp);
          temp = [];
        }
      }
      if (temp.length > 0) {
        list.push([...temp]);
      }
      console.log('【CPublicMallRecommend】goodsList = ', list);
      return list;
    },
  },
  watch: {
    currentGid(val) {
      console.log('【CPublicMallRecommend】watch currentGid = ', val);
      this.getMallRecommendGoodsList();
    },
  },
  mounted() {
    this.initialize();
    if (this.$isInEditor) {
      this.list = [
        {
          goodsImg: 'https://static.svip.game.qq.com/dc468b0570ffe67fa19df20913689f9e.png',
          presentPrice: 16800,
          originalPrice: 0,
          goodsName: '1巅峰·M4涂装组合',
        },
        {
          goodsImg: 'https://static.svip.game.qq.com/bc935c15ccd7a8a189bb9238c266c5da.png',
          presentPrice: 8800,
          originalPrice: 0,
          goodsName: '2跨系统角色转移卡',
        },
        {
          goodsImg: 'https://static.svip.game.qq.com/5dc4ef445d41561d9d36537b4bff752d.png',
          presentPrice: 300,
          originalPrice: 0,
          goodsName: '3AKS-74U全装包',
        },
        {
          goodsImg: 'https://static.svip.game.qq.com/c901a16fbd0214ffbce05ecc87a02f8b.png',
          presentPrice: 3000,
          originalPrice: 0,
          goodsName: '4S8赛季进阶手册激活卡',
        },
        {
          goodsImg: 'https://static.svip.game.qq.com/dc468b0570ffe67fa19df20913689f9e.png',
          presentPrice: 16800,
          originalPrice: 0,
          goodsName: '5巅峰·M4涂装组合',
        },
        {
          goodsImg: 'https://static.svip.game.qq.com/bc935c15ccd7a8a189bb9238c266c5da.png',
          presentPrice: 8800,
          originalPrice: 0,
          goodsName: '6跨系统角色转移卡',
        },
        {
          goodsImg: 'https://static.svip.game.qq.com/5dc4ef445d41561d9d36537b4bff752d.png',
          presentPrice: 300,
          originalPrice: 0,
          goodsName: '7AKS-74U全装包',
        },
        {
          goodsImg: 'https://static.svip.game.qq.com/c901a16fbd0214ffbce05ecc87a02f8b.png',
          presentPrice: 3000,
          originalPrice: 0,
          goodsName: '8S8赛季进阶手册激活卡',
        },
        {
          goodsImg: 'https://static.svip.game.qq.com/5dc4ef445d41561d9d36537b4bff752d.png',
          presentPrice: 300,
          originalPrice: 0,
          goodsName: '9AKS-74U全装包',
        },
        {
          goodsImg: 'https://static.svip.game.qq.com/c901a16fbd0214ffbce05ecc87a02f8b.png',
          presentPrice: 3000,
          originalPrice: 0,
          goodsName: '10S8赛季进阶手册激活卡',
        },
      ];
    }
  },
  methods: {
    async initialize() {
      this.$onLogined(() => {
        this.getMallRecommendGoodsList();
        this.autoPlay();
        this.initListenScrollerEvent();
      });
    },
    /**
     * 自动轮播
     */
    autoPlay() {
      const { autoPlay = false, autoplaySpeed = 3000  } = this.configurationData;
      if (!autoPlay) return;
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
      }
      const that = this;
      this.autoPlayTimer = setTimeout(() => {
        that.touchMoveNext();
      }, autoplaySpeed);
    },
    touchMovePre() {
      const { currentIndex } = this;
      this.touchMoveEvent(currentIndex - 1);
    },
    touchMoveNext() {
      const { currentIndex } = this;
      this.touchMoveEvent(currentIndex + 1);
    },
    touchMoveEvent(index) {
      let idx = index;
      if (index < 0) {
        idx = this.goodsList.length - 1;
      }
      if (index > this.goodsList.length - 1) {
        idx = 0;
      }
      this.autoPlay();
      this.currentIndex = idx;
      const { offsetWidth } = this.$refs.goodsListScroller;
      this.$refs.goodsListScroller.style.webkitTransform = `translate3d(${-1 * idx * offsetWidth}px, 0, 0)`;
    },
    // 增加监听
    initListenScrollerEvent() {
      if (!this.$refs.displayGoodsContainer) return ;
      this.scrollContainerMain = this.$refs.displayGoodsContainer;
      this.delta = {};
      //  开始滑动
      this.scrollContainerMain.addEventListener('touchstart', this.touchStartEvent);
      //  滑动结束
      this.scrollContainerMain.addEventListener('touchend', this.touchEndEvent);
    },
    touchStartEvent(event) {
      event.stopPropagation();
      this.delta = this.delta || {};
      this.delta.x = event.touches[0].pageX;
      this.delta.y = event.touches[0].pageY;
    },
    touchEndEvent(event) {
      event.stopPropagation();
      let { x, y } = this.delta;
      x -= event.changedTouches[0].pageX;
      y -= event.changedTouches[0].pageY;
      // 向左或向右滑动 距离不够
      if (Math.abs(x) < 5 && Math.abs(y) < 5) {
        return false;
      }
      const { currentIndex } = this;
      // 一定有向左滑动或向右滑动
      if (Math.abs(x) >= Math.abs(y)) {
        if (x > 0) {
          // ,右滑
          if (currentIndex + 1 <= this.goodsList.length - 1) {
            this.touchMoveEvent(currentIndex + 1);
          }
        } else {
          // ,左滑
          if (currentIndex - 1 >= 0) {
            this.touchMoveEvent(currentIndex - 1);
          }
        }
      }
    },
    async getMallRecommendGoodsList() {
      this.goodsList = [];
      this.list = [];
      const channelMap = {
        'act.xinyue.qq.com': 'vip',
        'act.gbot.qq.com': 'gbot',
        'act.supercore.qq.com': 'svip',
        'ceiba.shanxian.qq.com': 'spark',
      };
      const domain = window.location.href.split('//')[1]?.split('/')[0];
      const channelId = channelMap[domain];
      console.log('domain', domain, channelId);
      const urlMap = {
        test: 'https://bgw-t.xinyue.qq.com/mall.api/HomepageRecommend',
        prerelease: 'https://bgw-p.xinyue.qq.com/mall.api/HomepageRecommend',
        prod: 'https://bgw.xinyue.qq.com/mall.api/HomepageRecommend',
      };
      const requestEnv = window?.CEIBA_ENV || 'prod';
      console.log('requestUrl', window.CEIBA_ENV, requestEnv, urlMap[requestEnv]);
      console.log('【CPublicMallRecommend】getMallRecommendGoodsList channelId = ', channelId);
      const url = urlMap[requestEnv];
      const response = await this.$requestInstance.post(url, { gid: this.currentGid }, {
        headers: {
          'T-CHANNEL-ID': channelId,
          'Content-Type': 'application/json',
        },
      });
      console.log('【CPublicMallRecommend】getMallRecommendGoodsList response = ', response);
      const { ret,  msg, data = {} } = response;
      if (ret !== 0) {
        this.$alert({ msg: msg || '网络繁忙，请稍后再试' });
        return;
      }
      const { goodsList = [] } = data || {};
      this.list = (goodsList || []).map((item) => {
        const { goodsImg, presentPrice = 0, originalPrice = 0, goodsName } = item;
        return { goodsImg, presentPrice, originalPrice, goodsName };
      });

      console.log('【CPublicMallRecommend】getMallRecommendGoodsList list = ', this.list);
    },
    getStringSize(value) {
      if (!value) {
        return 0;
      }
      const charCount = value.split('').reduce((prev, curr) => {
        // 英文字母和数字等算一个字符；这个暂时还不完善；
        if (/[a-z]|[0-9]|[,;.!@#-+/\\$%^*()<>?:"'{}~]/i.test(curr)) {
          return prev + 1;
        }
        // 其他的算是2个字符
        return prev + 2;
      }, 0);

      // 向上取整，防止出现半个字的情况
      return Math.ceil(charCount / 2);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>

